export default __webpack_public_path__ + "static/media/pictogramBeaconDownload48.efd7b172.svg";